import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { LocationTwoIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createJourneyPlace } from '../../api/journey-place/create-journey-place'
import UserNavBar from '../../components/elements/nav-bar'
import JourneyPlaceForm from '../../components/pages/journey-places/journey-place-form'
import { Paths } from '../../lib/constants/path'
import { twoButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

const JourneyPlaceCreatePage = () => {
  const { back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createJourneyPlace,
    onError: showAxiosError,
    onSuccess: () => toast.success('Lieu de séjour créé avec succès')
  })

  return (
    <div>
      <UserNavBar title={'Créer un lieu de séjour'} icon={LocationTwoIcon} />
      <div className={'h-4'} />

      <Box>
        <JourneyPlaceForm
          buttonsConfig={twoButtonsConfig({
            onConfirm: async (values) => {
              await mutateAsync(values)
              back(Paths.JOURNEY_PLACE_LIST_PAGE)
            },
            onCancel: () => back()
          })}
        />
      </Box>
    </div>
  )
}

export default JourneyPlaceCreatePage
